import type { WeddingSettings } from '@shared/settings'
import { Seccion, tieneTexto, urlSegura } from './comunes'

/* ===========================================================================
   Nuestra historia — línea de tiempo.

   Sin riel vertical: el único eje vertical de la página es el cordón. Aquí los
   momentos se separan con reglas finas y la fecha va en font-mono, en su
   propia columna cuando hay ancho para ella.
   =========================================================================== */

type Evento = WeddingSettings['story'][number]

function tieneAlgo(evento: Evento): boolean {
  return tieneTexto(evento.title) || tieneTexto(evento.body) || tieneTexto(evento.photoUrl)
}

export function hayHistoria(story: WeddingSettings['story']): boolean {
  return story.some(tieneAlgo)
}

export default function Historia({ story }: { story: WeddingSettings['story'] }) {
  const eventos = story.filter(tieneAlgo)

  return (
    <Seccion id="historia" eyebrow="Nuestra historia" titulo="Cómo llegamos hasta aquí">
      <ol className="flex flex-col">
        {eventos.map((evento, i) => {
          const foto = urlSegura(evento.photoUrl)
          return (
            <li
              key={evento.id}
              className={i === 0 ? 'pb-6 last:pb-0' : 'border-t border-palo/70 py-6 last:pb-0'}
            >
              <div className="sm:flex sm:gap-8">
                {tieneTexto(evento.date) && (
                  <p className="tabular shrink-0 pt-1 font-mono text-xs uppercase tracking-wider text-palo-hondo sm:w-32">
                    {evento.date}
                  </p>
                )}
                <div className="mt-2 min-w-0 sm:mt-0 sm:flex-1">
                  {tieneTexto(evento.title) && (
                    <h3 className="font-display text-2xl text-tinta">{evento.title}</h3>
                  )}
                  {tieneTexto(evento.body) && (
                    <p className="mt-3 whitespace-pre-line leading-relaxed text-tinta/85">
                      {evento.body}
                    </p>
                  )}
                </div>
                {foto && (
                  <img
                    src={foto}
                    alt={tieneTexto(evento.title) ? evento.title : ''}
                    loading="lazy"
                    decoding="async"
                    className="mt-4 aspect-square w-full max-w-sm rounded-md object-cover sm:mt-0 sm:w-40 sm:shrink-0"
                  />
                )}
              </div>
            </li>
          )
        })}
      </ol>
    </Seccion>
  )
}
